import { useCallback, useState } from "react"

import { MIN_DOTS_DISPLAY_TIME } from "./config"

export function useBotTyping() {
  const [isBotTyping, setIsBotTyping] = useState(false)

  const showTypingIndicator = useCallback((time = MIN_DOTS_DISPLAY_TIME) => {
    setIsBotTyping(true)

    return new Promise((resolve) => {
      setTimeout(() => {
        setIsBotTyping(false)
        resolve()
      }, time)
    })
  }, [])

  const stopTypingIndicator = useCallback(() => setIsBotTyping(false), [])

  return { isBotTyping, showTypingIndicator, stopTypingIndicator }
}
